import { render, staticRenderFns } from "./PrimeTitle.vue?vue&type=template&id=c9fcdc70&scoped=true&"
import script from "./PrimeTitle.vue?vue&type=script&lang=js&"
export * from "./PrimeTitle.vue?vue&type=script&lang=js&"
import style0 from "./PrimeTitle.vue?vue&type=style&index=0&id=c9fcdc70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9fcdc70",
  null
  
)

export default component.exports